import VueI18n from 'vue-i18n';
import localize from '@sbvr/lbe-localization';

const i18n: VueI18n = localize(
  window.sbvrenv.BROWSER_LOCALE,
  'login-panel'
);

export function useI18n (): VueI18n {
  return i18n;
}

export default i18n;
